/* istanbul ignore file */
export { CarouselComponentsModule } from './carousel.module';
export { CarouselComponent } from './carousel.component';
export type { Carousel, PopularItem } from './carousel.types';
